import rocketPin from "../assets/pins/rocket.png";
import planetPin from "../assets/pins/planet.png";
import starPin from "../assets/pins/star.png";
import galaxyPin from "../assets/pins/galaxy.png";

export const PIN_IMAGES = {
  ROCKET: rocketPin,
  PLANET: planetPin,
  STAR: starPin,
  GALAXY: galaxyPin
};

export const normalizarCodigoPin = (pinOuCodigo) => {
  if (typeof pinOuCodigo === "string") {
    return pinOuCodigo
      .trim()
      .toUpperCase();
  }

  return String(
    pinOuCodigo?.codigo ||
      pinOuCodigo?.pin_codigo ||
      ""
  )
    .trim()
    .toUpperCase();
};

export const getPinImage = (pin) => {
  const codigo =
    normalizarCodigoPin(pin);

  return (
    PIN_IMAGES[codigo] ||
    pin?.imagem_url ||
    pin?.pin_imagem ||
    null
  );
};

export const getPinThemeClass = (pinOuCodigo) =>
  normalizarCodigoPin(pinOuCodigo)
    .toLowerCase();